function fn_comp_slider() {
    var slider = $(".comp_slider").find(".slick");

    slider.slick({
        infinite: true,
        speed: 500,
        fade: false,
        cssEase: 'ease',
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        pauseOnHover: false,
        dots: false,
        nextArrow: '<span class="icon icon-arr_rght"></span>',
        prevArrow: '<span class="icon icon-arr_lft"></span>'
    });

    var clients_slider = $('.clients_slider');

    clients_slider.slick({
        infinite: true,
        speed: 500,
        fade: false,
        cssEase: 'ease',
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        pauseOnHover: false,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        nextArrow: '<span class="icon icon-arr_rght"></span>',
        prevArrow: '<span class="icon icon-arr_lft"></span>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    })
}